<dx-popup
  [width]="450"
  [height]="400"
  [showTitle]="true"
  class="vehicles-tracker-icons-selector-popup"
  [title]="'Icons ' + item?.name"
  [dragEnabled]="true"
  (onHidden)="closed($event)"
  [closeOnOutsideClick]="false"
  [(visible)]="visible">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Enregistrer',
            onClick: save
        }">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Annuler',
            onClick: close
        }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <app-vehicles-tracker-state-icon
      [settings]="item.settings"
      [stateIcon]="item.settings.getTrackerStateIcon('default', 'assets/icons/tractor-red.svg')"></app-vehicles-tracker-state-icon>
    <app-vehicles-tracker-state-icon
      [settings]="item.settings"
      [stateIcon]="item.settings.getTrackerStateIcon('idle', 'assets/icons/tractor-orange.svg')"></app-vehicles-tracker-state-icon>
    <app-vehicles-tracker-state-icon
      [settings]="item.settings"
      [stateIcon]="item.settings.getTrackerStateIcon('offline', 'assets/icons/tractor-gray.svg')"></app-vehicles-tracker-state-icon>
    <app-vehicles-tracker-state-icon
      [settings]="item.settings"
      [stateIcon]="item.settings.getTrackerStateIcon('moving', 'assets/icons/tractor-green.svg')"></app-vehicles-tracker-state-icon>
  </div>
</dx-popup>
<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.vehicles-tracker-icons-selector-popup' }"
  [visible]="loadIndicatorVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
